<template>
  <div>
    <div class="divider divider--horizontal"></div>
    <div style="display: flex; flex-direction: row;">
      <span style="color: #5d9cec; flex: 0 0 auto; line-height: 32px;">{{
        orderStr
      }}</span>
      <div style="flex: 1 1 0%;">
        <div style="padding: 0 12px;">
          <div style="font-size: 16px; line-height: 32px;">{{ title }}</div>
        </div>
        <div style="padding: 12px;">
          <div style="font-size: 14px; color: grey;">{{ description }}</div>
        </div>
        <gallery-mobile :pictures="pictures" />
        <div v-for="(it, idx) in valueTextLines" :key="idx">
          {{ it }}
        </div>
        <gallery-mobile v-if="type === 8" :pictures="imagesProxy" />
        <div v-if="extra">说明：{{ extra }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { labelFormat } from "@/utils/SchemaHelper";
import { AreaSharedCache } from "@/utils/AreaSharedCache";
import GalleryMobile from "@/components/common/GalleryMobile";
export default {
  name: "answer-blank-item-mobile",
  components: { GalleryMobile },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    extra: {
      type: String,
    },
    type: {
      type: Number,
      required: true,
    },
    order: {
      type: Number,
      required: true,
    },
    pictures: {
      type: Array,
    },
    schema: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      valueTextLines: [],
    };
  },
  computed: {
    orderStr() {
      return `${this.$props.order}`.padStart(2, "0");
    },
    imagesProxy() {
      if (this.type !== 8) {
        return [];
      }
      const array = this.value ? JSON.parse(this.value) : [];
      if (Array.isArray(array)) {
        return array;
      }
      return [];
    },
  },
  watch: {
    value() {
      this.updateValueText();
    },
    type() {
      this.updateValueText();
    },
    schema() {
      this.updateValueText();
    },
  },
  methods: {
    async buildValueText() {
      const { value, type, schema } = this.$props;
      if (!value) {
        return [];
      }
      if (type === 1 || type === 2 || type === 6) {
        return [value];
      }
      if (type === 7) {
        const array = value
          .split(",")
          .map((it) => Number.parseInt(it))
          .filter((it) => !isNaN(it));
        if (!array.length) {
          return array;
        }
        await AreaSharedCache.loadByList(array);
        const str = array
          .map((it) => {
            const item = AreaSharedCache.getItem(it);
            return item ? item.name : it;
          })
          .join("/");
        return [str];
      }
      if (type === 9) {
        return [value];
      }
      if (type === 10) {
        const obj = value ? JSON.parse(value) : {};
        const text = obj.address || "";
        return [text];
      }
      const { options } = schema;
      if (Array.isArray(options) && options.length) {
        if (type === 4) {
          const values = value.split(",");
          if (values.length) {
            return options
              .filter((item) =>
                values.some((it) => `${it}` === `${item.order}`)
              )
              .map((it) => labelFormat(it.format, it.text));
          }
          return [];
        }
        return options
          .filter((it) => `${it.order}` === `${value}`)
          .map((it) => labelFormat(it.format, it.text));
      }
      return [];
    },
    async updateValueText() {
      this.valueTextLines = await this.buildValueText();
    },
  },
  mounted() {
    this.updateValueText();
  },
};
</script>
<style>
.border-bottom.van-cell.van-field {
  font-size: 18px;
  line-height: 24px;
  padding-bottom: 0px;
  padding-left: 0px;
  padding-right: 0px;
  border: none;
  border-bottom: 1px solid #c7c7c7;
  border-radius: unset;
}
.van-dropdown-menu__title {
  flex: 1 1 0%;
  margin: 5px;
}
</style>
